import React from "react";
import { Spin } from "antd";
import { Row, Col } from "antd";
import "./FullScreenLoader.css";

const FullScreenLoader = () => {
  return (
    <div className="fullscreen-loader">
      <Row justify="center" align="middle" style={{ height: "100vh" }}>
        <Col>
          <Spin size="large" />
        </Col>
      </Row>
    </div>
  );
};

export default FullScreenLoader;
